import { ApiStatus } from '../../types';
import {
    mainIncomeDefaultAEM,
    MainIncomeDetail,
    MainIncomeEndpoints,
    MainIncomeState,
} from './mainIncomeTypes';

export const defaultMainIncomeDetails: MainIncomeDetail = {
    incomeId: 0,
    taxSelector: '',
    frequency: '',
    amount: 201.0,
};

export const mainIncomeApiEndpointsDefault: MainIncomeEndpoints = {
    upsertMainIncomeUrl: '/updateMainIncome',
    getMainIncomeUrl: '/getMainIncome',
};

export const initialStateMainIncome: MainIncomeState = {
    incomeDetails: defaultMainIncomeDetails,
    apiStatus: ApiStatus.Idle,
    content: mainIncomeDefaultAEM,
    apiEndpoints: mainIncomeApiEndpointsDefault,
};

